import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex, { ALIGN_CLASS, GAP_CLASS } from "components/Flex";
import { idPropType } from "constants/app";
import { ArrowRightIcon } from "lucide-react";
import {
  bool,
  func,
  number,
  object,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectOutlineOwner } from "slices/proposalOutline/selectors";

import { useLinkGrouping } from "../useLinkGrouping";
import { buildWritingEditorUrl } from "../utils";
import classes from "./ActionsButton.module.scss";
import DeleteButton from "./DeleteButton";
import UnlinkButton from "./UnlinkButton";

const ActionsButton = ({
  getTable,
  isEditing,
  isLockedByOtherUser,
  nextgenDocumentId,
  nextgenFileName,
  row,
  sectionId,
  title,
}) => {
  const navigate = useNavigate();
  const owner = useSelector(selectOutlineOwner);

  const { isFirstInGroup, isLinked } = useLinkGrouping(
    row,
    nextgenDocumentId,
    getTable
  );

  const onClickDocument = (e) => {
    e.stopPropagation();
    const url = buildWritingEditorUrl(owner, nextgenDocumentId);
    if (url) {
      navigate(url);
    }
  };

  if (isLockedByOtherUser) {
    return null;
  }

  if (isEditing) {
    return <DeleteButton sectionId={sectionId} title={title} />;
  }

  return (
    <Flex
      alignItems={ALIGN_CLASS.center}
      className={classes.actions_flex}
      data-show-on-row-hover
      gap={GAP_CLASS.GAP_200}
      justifyContent="flex-end"
    >
      {isLinked && isFirstInGroup && (
        <UnlinkButton
          nextgenDocumentId={nextgenDocumentId}
          nextgenFileName={nextgenFileName}
          sectionId={sectionId}
        />
      )}

      <NewButton
        data-testid="go-to-doc-btn"
        onClick={onClickDocument}
        rightIcon={<ArrowRightIcon width={16} height={16} />}
        size={NewButtonSize.sm}
        variant={NewButtonVariant.l1}
      >
        Go To Doc
      </NewButton>
    </Flex>
  );
};

ActionsButton.propTypes = {
  getTable: func,
  isEditing: bool,
  isLockedByOtherUser: bool,
  nextgenDocumentId: idPropType,
  nextgenFileName: string,
  row: shape({
    getCanExpand: func,
    getIsExpanded: func,
    id: oneOfType([number, string]),
    index: number,
    original: object,
  }),
  sectionId: idPropType,
  title: string,
};

export default ActionsButton;
